/**
 * URLs externas de la aplicación centralizadas en un solo punto.
 * Las URLs del API se resuelven en `src/environments`; aquí solo van
 * destinos externos que no dependen del entorno.
 */
export const EXTERNAL_URLS = {
  /** Landing pública de Signly (enlace del footer). */
  LANDING_PAGE: 'https://signly.apologs.com',
  /** Proveedor público de tasa de cambio COP/USD (sin API key). */
  EXCHANGE_RATE_API: 'https://open.er-api.com/v6/latest/COP'
} as const;
